export default {

    getCars(context) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            fetch(this.state.api + 'car/get.php', {
                    method: 'POST',
                    body: JSON.stringify({
                        Token: this.state.token
                    })
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            let obj = JSON.parse(val);
                            this.state.cars = obj;
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.cars = null;
                    this.state.hideLoadingIndicator = true;
                    reject('Greška preuzimanja popisa vozila.');
                });
        });
    },

    searchCars(context, payload) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            payload.Token = this.state.token;
            fetch(this.state.api + 'car/check.php', {
                    method: 'POST',
                    body: JSON.stringify(payload)
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            let obj = JSON.parse(val);
                            this.state.cars = obj;
                            resolve('Učitano');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.cars = null;
                    this.state.hideLoadingIndicator = true;
                    reject('Greška pretraživanja vozila.');
                });
        });
    },

    deleteCar(context, carID) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            fetch(this.state.api + 'car/delete.php', {
                    method: 'POST',
                    body: JSON.stringify({
                        ID: carID,
                        Token: this.state.token
                    })
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            if (val === '1') resolve('Obrisano');
                            if (val === '0') reject('Greška');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });
        });
    },

    insertCar(context, payload) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            payload.Token = this.state.token;
            fetch(this.state.api + 'car/insert.php', {
                    method: 'POST',
                    body: JSON.stringify(payload)
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            if (val === '1') resolve('Dodano');
                            if (val === '0') reject('Greška');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });
        });
    },

    updateCar(context, payload) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            payload.Token = this.state.token;
            fetch(this.state.api + 'car/update.php', {
                    method: 'POST',
                    body: JSON.stringify(payload)
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            if (val === '1') resolve('Spremljeno');
                            if (val === '0') reject('Greška');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });
        });
    },

    refreshCar(context, carID) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            fetch(this.state.api + 'car/refresh.php', {
                    method: 'POST',
                    body: JSON.stringify({
                        ID: carID,
                        Token: this.state.token
                    })
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            if (val === '1') resolve('Osvježeno');
                            if (val === '0') reject('Greška');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });
        });
    },

    getEventForSpecificCar(context, carID) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            fetch(this.state.api + 'event/get.php', {
                    method: 'POST',
                    body: JSON.stringify({
                        carID,
                        Token: this.state.token
                    })
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            let obj = JSON.parse(val);
                            this.state.events = obj;
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.events = null;
                    this.state.hideLoadingIndicator = true;
                    reject('Greška preuzimanja rezervacija');
                });
        });
    },

    insertEvent(context, payload) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            payload.Token = this.state.token;
            fetch(this.state.api + 'event/insert.php', {
                    method: 'POST',
                    body: JSON.stringify(payload)
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            if (val === '1') resolve('Dodano');
                            if (val === '0') reject('Greška');
                            if (val === '2') reject('Greška. Vozilo nije slobodno u navedenom intervalu.');
                            if (val === '3') reject('Greška. Pogrešni unos datuma preuzimanja i povratka.');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });

        });
    },

    updateEvent(context, payload) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            payload.Token = this.state.token;
            fetch(this.state.api + 'event/update.php', {
                    method: 'POST',
                    body: JSON.stringify(payload)
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            if (val === '1') resolve('Spremljeno');
                            if (val === '0') reject('Greška');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });
        });
    },

    deleteEvent(context, payload) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            fetch(this.state.api + 'event/delete.php', {
                    method: 'POST',
                    body: JSON.stringify({
                        ID: payload.ID,
                        carID: payload.carID,
                        Token: this.state.token
                    })
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            resolve('Obrisano');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });
        })
    },

    getCategories(context) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            fetch(this.state.api + 'categories/get.php', {
                    method: 'POST',
                    body: JSON.stringify({
                        Token: this.state.token
                    })
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            let obj = JSON.parse(val);
                            this.state.categories = obj;
                            this.commit('parseCategories');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.events = null;
                    this.state.hideLoadingIndicator = true;
                    reject('Greška preuzimanja liste kategorija');
                });
        });
    },

    insertCategories(context, payload) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            payload.Token = this.state.token;
            fetch(this.state.api + 'categories/insert.php', {
                    method: 'POST',
                    body: JSON.stringify(payload)
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            if (val === '1') resolve('Dodano');
                            if (val === '0') reject('Greška');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });
        });
    },

    updateCategories(context, payload) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            payload.Token = this.state.token;
            fetch(this.state.api + 'categories/update.php', {
                    method: 'POST',
                    body: JSON.stringify(payload)
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            if (val === '1') resolve('Spremljeno');
                            if (val === '0') reject('Greška');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });
        });
    },

    deleteCategories(context, payload) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            fetch(this.state.api + 'categories/delete.php', {
                    method: 'POST',
                    body: JSON.stringify({
                        ID: payload.ID,
                        carID: payload.carID,
                        Token: this.state.token
                    })
                })
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            resolve('Obrisano');
                        })
                    }
                    if (res.status === 401) {
                        reject('Neovlašteni pristup.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });
        });
    },

    login(context, payload) {
        return new Promise((resolve, reject) => {
            this.state.hideLoadingIndicator = false;
            const uri = this.state.api + 'login.php';
            const opt = {
                method: 'POST',
                body: JSON.stringify(payload)
            };
            fetch(uri, opt)
                .then(res => {
                    if (res.status === 200) {
                        res.text().then(val => {
                            const u = JSON.parse(val);
                            this.state.token = u.Token;
                            resolve();
                        })
                    }
                    if (res.status === 401) {
                        reject('Prijava nije uspjela.');
                    }
                    if (res.status === 500 || res.status === 404) {
                        reject('Greška na serveru.');
                    }
                    this.state.hideLoadingIndicator = true;
                })
                .catch(err => {
                    this.state.hideLoadingIndicator = true;
                    reject('Greška');
                });
        });
    }

}